import { render, staticRenderFns } from "./FaqAccordionWidget.vue?vue&type=template&id=459ef44a"
import script from "./FaqAccordionWidget.vue?vue&type=script&lang=js"
export * from "./FaqAccordionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports